import { EntityHandler, EntityListResult, SectionHandlerGroup, FormSectionHandler } from '../entity.handler';
import { IKuiTableCol } from 'app/key-ui';
import { Injectable } from '@angular/core';
import { IoTypeResponse, IoTypeCreateRequest, IoTypeUpdateRequest } from '@key-telematics/fleet-api-client';
import { AdminEditorService } from '../../admin.service';
import { GridColumnHelper, EnumToComboValues } from '../utils';
import { IoTypeDetailsSectionHandler, IO_TYPES } from './details.section';
import { ICONS } from '../icons';
import { RegisterEntityHandler } from '../../entities';

@RegisterEntityHandler('iotype')
@Injectable()
export class IoTypeHandler extends EntityHandler<IoTypeResponse> {

    constructor(
        admin: AdminEditorService
    ) {
        super(admin);
    }

    states = ['active', 'deleted'];

    listEntities(ownerId: string, offset: number, limit: number, sort: string, filter: string): Promise<EntityListResult> {
        return this.admin.getCached(`listIoTypes/${ownerId}/${offset}/${limit}/${sort}/${filter}`, api => api.entities.listIoTypes(ownerId, false, offset, limit, sort, filter), 3).then(response => ({
            ...response,
            type: 'iotype',
            title: this.admin.i18n.instant('ADMIN.ENTITIES.IOTYPES'),
        }));
    }

    getEntity(id: string): Promise<IoTypeResponse> {
        return this.admin.getCached(`getIoType/${id}`, api => api.entities.getIoType(id), 10);
    }

    createEntity(ownerId: string, entity: IoTypeCreateRequest): Promise<IoTypeResponse> {
        entity.ownerId = ownerId;
        return this.admin.applyUpdate(api => api.entities.createIoType(entity));
    }

    setEntityState(entity: any, state: string): Promise<any> {
        return this.admin.applyUpdate(api => api.entities.updateIoType(entity.id, { state: state as any }));
    }   

    getGridColumns(_ownerId: string): Promise<IKuiTableCol[]> {
        const grid = new GridColumnHelper(this.admin.i18n, 'ADMIN.EDITORS.IOTYPE.COLUMNS');
        const columns: IKuiTableCol[] = [
            grid.IconTextColumn('name', 'NAME', ICONS.iotype),
            grid.ComboColumn('type', 'TYPE', EnumToComboValues(this.admin.i18n, 'ADMIN.EDITORS.IOTYPE.TYPES', IO_TYPES), 100),
            grid.ComboColumn('state', 'STATE', EnumToComboValues(this.admin.i18n, 'ADMIN.STATES', this.states, ['deleted']), 80),
            grid.TimeAgoColumn('modifiedDate', 'MODIFIED'),
        ];
        return Promise.resolve(columns);
    }

    getEditorSections(ownerId: string, _entity: any): Promise<SectionHandlerGroup<IoTypeResponse>[]> {
        return Promise.resolve([{
            name: this.admin.i18n.instant('ADMIN.EDITOR.INFORMATION'),
            sections: [
                new IoTypeDetailsSectionHandler(this.admin, ownerId, false),
            ],
        }]);
    }

    getCreationSections(ownerId: string): Promise<{ entityType: string, entity: IoTypeUpdateRequest, sections: FormSectionHandler<IoTypeResponse, any>[] }> {
        return Promise.resolve({
            entityType: 'iotype',
            entity: {}, // set up some defaults if you want
            sections: [
                new IoTypeDetailsSectionHandler(this.admin, ownerId, true),
            ],
        });
    }

}












